import type { SourceMode } from '../../controllers/chat-mode-store/types';

import {
	areRovoControlsSuppressed,
	type RovoControlsSuppressedParams,
} from './areRovoControlsSuppressed';

export type SourceModeForSubmitParams = RovoControlsSuppressedParams & {
	sourceMode: SourceMode | undefined;
};

export const getSourceModeForSubmit = ({
	isAgentMentionActive,
	isSpecialistPromptInput,
	sourceMode,
}: SourceModeForSubmitParams): SourceMode | undefined =>
	areRovoControlsSuppressed({ isAgentMentionActive, isSpecialistPromptInput })
		? undefined
		: sourceMode;
